import $ from 'jquery';
import { t } from 'i18next';
import serialize from 'serialize-array';
import Messenger from 'messenger';
import { getSignInUrl } from 'helpers/shared';

export default function obiqAJAX(
  opts = {},
  actionName,
  serializeData = false,
  defaultErrorOnFail = true
) {
  const options = {
    ...(typeof opts === 'string' ? { url: opts } : opts),
    data: serializeData ? serialize(opts.data) : opts.data,
    beforeSend: (jqXHR, settings) => {
      Object.assign(jqXHR, {
        data: settings.data,
        method: settings.method,
        url: settings.url,
      });

      if (opts.beforeSend) {
        opts.beforeSend(jqXHR, settings);
      }
    },
  };

  return $.ajax(options).fail((jqXHR, textStatus, errorThrown) => {
    const statusCode = jqXHR.status;

    if (statusCode === 401) {
      window.location = getSignInUrl();
      return;
    }

    if (errorThrown === 'abort') {
      // expected fail when the request gets aborted by a new superseding request.
      return;
    }

    if (defaultErrorOnFail) {
      Messenger().post({ type: 'error', message: t('Shared.anErrorOccured') });
    }

    if (process.env.NODE_ENV === 'development') {
      console.error(`obiqAJAX ERROR: ${textStatus}`, errorThrown, actionName);
    }
  });
}
